export const JOINT_STATES = {
  FIRST_ORDER: 'FIRST_ORDER',
  ADDITIONAL_ORDER: 'ADDITIONAL_ORDER',
  NOT_JOINT: 'NOT_JOINT',
};
export const orderNumberArray = new Array(9)
  .fill(0)
  .map((_value, index) => index + 2);
